import {propOr} from 'ramda'

import {defaultLanguage, isEnabledLanguage} from './locale'

/**
 * Maps an application language code to the locale folder name used by the
 * `cldr-dates-full` package (e.g. `pt-BR` → `pt`). Falls back to the default
 * language when the input is not enabled.
 * @param locale The application language code
 * @returns The folder name to use under `js/cldr-dates-full/main`
 */
export const getCldrDatesLocale = (locale: string): string => {
  if (!isEnabledLanguage(locale)) return defaultLanguage

  return propOr(locale, locale, {
    'en-GB': 'en',
    'pt-BR': 'pt',
    'zh-HK': 'zh-Hans-HK',
    'zh-TW': 'zh',
    'zh-CN': 'zh',
    no: 'nb'
  })
}
